// The two answers the server gives a person with several companies when it
// cannot tell which one a request is for. Both open the picker; neither signs
// anyone out.

import { companyErrorCode, NOT_IN_COMPANY, PICKER_PATH } from './companies';
import {
  clearCompanyId,
  COMPANY_HEADER,
  getCompanyId,
  requireCompanyChoice
} from './companySession';

// The company a request was SENT for: what its X-Company-Id header said, or ''.
const sentCompanyId = (config) => {
  const headers = config?.headers;
  if (!headers) return '';
  const value =
    typeof headers.get === 'function'
      ? headers.get(COMPANY_HEADER)
      : headers[COMPANY_HEADER] ?? headers[COMPANY_HEADER.toLowerCase()];
  return value ? String(value) : '';
};

export function handleCompanyError(error, { goToPicker, currentPath }) {
  const code = companyErrorCode(error);
  if (!code) return null;
  // my-companies is what the picker itself reads; it is never a reason to open it.
  if (String(error?.config?.url ?? '').includes('my-companies')) return null;
  // An answer to a request sent before this tab chose its company (or for the
  // company it has since left) says nothing about the company it is in now.
  // Requests fired while the picker is open come back COMPANY_REQUIRED after a
  // company has been chosen, and reacting to them bounced the person straight
  // back to the picker — the "first click does nothing" bug.
  const current = getCompanyId();
  if (current && sentCompanyId(error?.config) !== current) return null;
  // The stored company is one they have lost; keeping it would refuse every request.
  if (code === NOT_IN_COMPANY) clearCompanyId();
  requireCompanyChoice();
  if (currentPath !== PICKER_PATH) goToPicker();
  return code;
}

export function installTenancyInterceptor(axiosInstance, { goToPicker, currentPath }) {
  return axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      handleCompanyError(error, { goToPicker, currentPath: currentPath() });
      return Promise.reject(error);
    }
  );
}
